//get hiring details
export const HIRE_DETAILS = "HIRE_DETAILS";
export const HIRE_DETAILS_SUCCESS = "HIRE_DETAILS_SUCCESS";
export const HIRE_DETAILS_FAILED = "HIRE_DETAILS_FALIED";
// save hiring details
export const SAVE_HIRE_DETAILS = "SAVE_HIRE_DETAILS";
export const SAVE_HIRE_DETAILS_SUCCESS = "SAVE_HIRE_DETAILS_SUCCESS";
export const SAVE_HIRE_DETAILS_FAILED = "SAVE_HIRE_DETAILS_FALIED";
